import type { FC } from 'react';
import { useState } from 'react';
import { Button } from 'src/common/components/button';
import { PRODUCT_NAME } from 'src/const/title';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';

import { CheckboxText } from './checkbox-text';

interface Props {
  onNext: (selectedReasons: boolean[], otherReason?: string) => void;
  onCancel: () => void;
}
const MAX_TEXTAREA_LENGTH = 100;

export const LogoffReason: FC<Props> = (props) => {
  const { t } = useAppTranslation();
  const REASONS = [
    t('components.logoff.reason_complex'),
    t('components.logoff.reason_needs_not_met'),
    t('components.logoff.reason_poor_experience'),
    t('components.logoff.reason_security_privacy'),
  ];
  const [reasons, setReasons] = useState<boolean[]>([false]);
  const [otherReason, setOtherReason] = useState<string>('');
  const isNoReason = reasons.every((hasReason) => !hasReason && otherReason.length === 0);
  return (
    <div className="flex flex-col w-[400px] px-[30px] overflow-y-auto">
      <div className="text-center text-t1-medium mt-10">{t('common.cancel_service')}</div>
      <div className="mt-5 mb-1.5 text-t2">{t('components.logoff.leave_reason')}</div>
      {REASONS.map((reason, index) => {
        return (
          <CheckboxText
            className="mt-3 "
            key={index}
            onCheck={(check) => {
              const newReasons = reasons.slice(0);
              newReasons[index] = check;
              setReasons(newReasons);
            }}
            content={reason}
          />
        );
      })}
      <div className="relative my-2 h-[112px]">
        <textarea
          placeholder={t('components.logoff.other_optional')}
          className="py-2 px-3 w-full bg-grey9 rounded border border-grey6 focus-within-border text-t2 resize-none"
          rows={4}
          maxLength={MAX_TEXTAREA_LENGTH}
          onChange={(e) => setOtherReason(e.target.value.trim())}
        ></textarea>
        <div className="absolute right-3 bottom-2">
          {otherReason.length} <span className="text-grey3">{`/ ${MAX_TEXTAREA_LENGTH}`}</span>
        </div>
      </div>
      <Button
        className="mb-4"
        disable={isNoReason}
        colorType="active"
        onClick={() => {
          props.onNext(reasons, otherReason);
        }}
      >
        {t('common.continue')}
      </Button>
      <Button onClick={props.onCancel} className="mb-5">
        {t('common.cancel')}
      </Button>
    </div>
  );
};
